module.exports = __webpack_public_path__ + "static/media/lock.99c74817.svg";